import Const from 'constants';

let ExposureMode = {
    setExposureModeFromStorage(value) {
        return (dispatch) => {
            dispatch(this.setExposureMode(value, {saveToStorage: false}));
        };
    },

    setExposureMode(value, options = {}) {
        return (dispatch) => {
            const {saveToStorage = true} = options;

            dispatch({
                type: Const.SET_EXPOSURE_MODE,
                value,
            });

            saveToStorage && dispatch(
                this.saveDataToStorage('exposureMode', function (state) {
                    const {exposureMode} = state;
                    return exposureMode.getExposureMode();
                }),
            );
        };
    },
};

export default ExposureMode;
